// extracted by mini-css-extract-plugin
export default {"noteList":"NotePage_noteList__HHfET","folderCard":"NotePage_folderCard__WJJ7G","notePage":"NotePage_notePage__tO11e"};